import { useMutation } from '@apollo/react-hooks';
import { pathOr } from 'ramda';
import { MARK_CONTENT_COMPLETED } from 'apollo/mutations';
import { KEYS } from 'components/evieOnboarding/utils/constants';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { useGetParams } from 'components/evieOnboarding/utils/useGetParams';

export const useMarkContentAsCompleted = () => {
  const [markContentAsCompleted] = useMutation(MARK_CONTENT_COMPLETED);
  const [userToken] = useLocalStorage(KEYS.USER_TOKEN);
  const { urlToken } = useGetParams();
  const token = userToken || urlToken;

  const validateParams = ({ contentId, contentType, patientProgramId }) => {
    if (!contentId || !contentType || !patientProgramId) {
      return false;
    }
    return true;
  };

  const handleMarkContentCompleted = async (params, callback) => {
    if (!validateParams(params)) {
      return { success: false, error: 'Required parameters missing' };
    }

    try {
      const response = await markContentAsCompleted({
        variables: params,
        context: {
          headers: {
            authorization: token ? `Bearer ${token}` : '',
            role: 'individual',
          },
        },
      });

      const success = pathOr(false, ['data', 'markContentAsCompleted', 'success'])(response);
      const error = pathOr(null, ['data', 'markContentAsCompleted', 'error'])(response);

      if (success && callback) {
        callback();
      }

      return { success, error };
    } catch (error) {
      return { success: false, error: error.message || 'Unknown error occurred' };
    }
  };

  return { markContentCompleted: handleMarkContentCompleted };
};
